import { useIsPromoActive } from '@/hooks/useIsPromoActive/useIsPromoActive';
import Stack from '@uikit/components/Stack/Stack';
import { ContentContainer } from '../ContentContainer/ContentContainer';
import { Headline } from '../Headline/Headline';
import { PricingBox } from '../PricingBox/PricingBox';
import { Text } from '../Text/Text';
import styles from './HomeAdvantage.module.scss';
import { PromoContent } from './PromoContent';

export const HomeAdvantage = () => {
  const isPromoActive = useIsPromoActive('ostern2025');

  return (
    <div className={styles.base}>
      <ContentContainer size="m" padding={false}>
        {isPromoActive ? (
          <PromoContent />
        ) : (
          <>
            <Headline className={styles.title} color="gradient">
              Unterwegs mit Heimvorteil
            </Headline>

            <Text
              className={styles.description}
              size={18}
              desktopScale={1.2}
              lineHeight={1.5}
              weight={300}
              align="center"
            >
              Mit der easyGo App können Sie nicht nur deutschlandweit laden,
              sondern erhalten bei über 1.000 enercity-Ladepunkten einen festen
              kWh-Preis. Preise an Ladestationen unserer Partner finden Sie
              transparent in der easyGo App.
            </Text>

            <div className={styles.priceWrapper}>
              <div>
                <Headline level={3} className={styles.title} color="gradient">
                  easyGo FixLaden
                </Headline>

                <Stack
                  gap={{ initial: '0.5rem', sm: '1.5rem' }}
                  flexDirection={{ initial: 'column' }}
                  justifyContent="center"
                  alignItems="center"
                >
                  <PricingBox
                    label="Grundpreis"
                    price={0}
                    priceSuffix="€/Monat"
                  />

                  <PricingBox
                    label="Normales Laden (AC)"
                    price={0.45}
                    subLabel="Standzeitzuschlag"
                    subPrice={0.05}
                    disclaimer={
                      'ab der 240. Minute nach Beginn eines Ladevorgangs'
                    }
                  />
                  <PricingBox
                    label="Schnelles Laden (DC)"
                    price={0.55}
                    subLabel="Standzeitzuschlag"
                    subPrice={0.05}
                    disclaimer={
                      'ab der 60. Minute nach Beginn eines Ladevorgangs'
                    }
                  />
                </Stack>
              </div>
              <div>
                <Headline level={3} className={styles.title} color="gradient">
                  easyGo SmartLaden
                </Headline>

                <Stack
                  gap={{ initial: '0.5rem', sm: '1.5rem' }}
                  flexDirection={{ initial: 'column' }}
                  justifyContent="center"
                  alignItems="center"
                >
                  <PricingBox
                    label="Grundpreis"
                    price={5.99}
                    priceSuffix="€/Monat"
                  />

                  <PricingBox
                    label="Normales Laden (AC)"
                    price={0.42}
                    subLabel="Standzeitzuschlag"
                    subPrice={0.05}
                    disclaimer={
                      'ab der 240. Minute nach Beginn eines Ladevorgangs'
                    }
                  />
                  <PricingBox
                    label="Schnelles Laden (DC)"
                    price={0.52}
                    subLabel="Standzeitzuschlag"
                    subPrice={0.05}
                    disclaimer={
                      'ab der 60. Minute nach Beginn eines Ladevorgangs'
                    }
                  />
                </Stack>
              </div>
            </div>
          </>
        )}

        <p className={styles.disclaimer}>
          Alle Preise inkl. 19% Mehrwertsteuer.
        </p>
        <p className={styles.disclaimer}>
          Der Standzeitzuschlag entfällt an AC-Ladestationen von enercity in der
          Zeit von 22:00 bis 08:00 Uhr.
        </p>
      </ContentContainer>
    </div>
  );
};
